// extracted by mini-css-extract-plugin
export var container = "container-module--container--1pAi7";
export var center = "container-module--center--240Zn";